(function($) {
    class W4D_RegisterToggle {
        constructor() {
            this.initSelectors();
            this.bindEvents();
        }

        initSelectors() {
            this.$sameAddressTriggers = $('.js-same-address-trigger');
            this.$addressContainers = $('.js-same-address');
        }

        bindEvents() {
            this.$sameAddressTriggers.on('change', (e) => this.same_address_toggle(e));
        }

        same_address_toggle(e) {
            const isChecked = $(e.target).prop('checked');

            this.$addressContainers.css('display', isChecked ? 'none' : 'grid');
        }
    }

    $(document).ready(() => new W4D_RegisterToggle());
})(jQuery);